import {
    LOGOUT_SUCCESS,
    LOGOUT_REQUEST,
    REFRESH_TOKEN_REQUEST,
    REFRESH_TOKEN_SUCCESS,
    REFRESH_TOKEN_FAILURE,
    CHANGE_PASSWORD_REQUEST,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAILURE,
    TOKEN_EXPIRED,
    GET_ADMIN_LIST_REQUEST,
    GET_ADMIN_LIST_SUCCESS,
    GET_ADMIN_LIST_FAILURE,
    GET_ADMIN_ROLE_LIST_REQUEST,
    GET_ADMIN_ROLE_LIST_SUCCESS,
    GET_ADMIN_ROLE_LIST_FAILURE,
    ADD_ADMIN_REQUEST,
    ADD_ADMIN_SUCCESS,
    ADD_ADMIN_FAILURE,
    EDIT_ADMIN_REQUEST,
    EDIT_ADMIN_SUCCESS,
    EDIT_ADMIN_FAILURE,
    DELETE_ADMIN_REQUEST,
    DELETE_ADMIN_SUCCESS,
    DELETE_ADMIN_FAILURE,
} from "../constant/actionTypes";

export const logout = payload => ({
    type: LOGOUT_REQUEST,
    payload
});

export const logoutSuccess = payload => ({
    type: LOGOUT_SUCCESS,
    payload
});

export const refreshToken = payload => ({
    type: REFRESH_TOKEN_REQUEST,
    payload
});

export const refreshTokenSuccess = payload => ({
    type: REFRESH_TOKEN_SUCCESS,
    payload
});

export const refreshTokenFailure = payload => ({
    type: REFRESH_TOKEN_FAILURE,
    payload
});

export const changePassword = payload => ({
    type: CHANGE_PASSWORD_REQUEST,
    payload
});

export const changePasswordSuccess = payload => ({
    type: CHANGE_PASSWORD_SUCCESS,
    payload
});

export const changePasswordFailure = payload => ({
    type: CHANGE_PASSWORD_FAILURE,
    payload
});

export const getAdminList = payload => ({
    type: GET_ADMIN_LIST_REQUEST,
    payload
});

export const getAdminListSuccess = payload => ({
    type: GET_ADMIN_LIST_SUCCESS,
    payload
});

export const getAdminListFailure = payload => ({
    type: GET_ADMIN_LIST_FAILURE,
    payload
});

export const getAdminRoleList = payload => ({
    type: GET_ADMIN_ROLE_LIST_REQUEST,
    payload
});

export const getAdminRoleListSuccess = payload => ({
    type: GET_ADMIN_ROLE_LIST_SUCCESS,
    payload
});

export const getAdminRoleListFailure = payload => ({
    type: GET_ADMIN_ROLE_LIST_FAILURE,
    payload
});

export const addAdmin = payload => ({
    type: ADD_ADMIN_REQUEST,
    payload
});

export const addAdminSuccess = payload => ({
    type: ADD_ADMIN_SUCCESS,
    payload
});

export const addAdminFailure = payload => ({
    type: ADD_ADMIN_FAILURE,
    payload
});

export const editAdmin = payload => ({
    type: EDIT_ADMIN_REQUEST,
    payload
});

export const editAdminSuccess = payload => ({
    type: EDIT_ADMIN_SUCCESS,
    payload
});

export const editAdminFailure = payload => ({
    type: EDIT_ADMIN_FAILURE,
    payload
});

export const deleteAdmin = payload => ({
    type: DELETE_ADMIN_REQUEST,
    payload
});

export const deleteAdminSuccess = payload => ({
    type: DELETE_ADMIN_SUCCESS,
    payload
});

export const deleteAdminFailure = payload => ({
    type: DELETE_ADMIN_FAILURE,
    payload
});

export const tokenExpired = payload => ({
    type: TOKEN_EXPIRED,
    payload
});